// 브라우저 기본 검증 말풍선을 한국어로 바꾼다.
//
// ── 왜 ───────────────────────────────────────────────────────────────────────
// <input type="email"> 같은 제약을 어기면 브라우저가 스스로 말풍선을 띄우는데, 그
// 문구의 언어는 **페이지가 아니라 브라우저 UI 언어**를 따른다. 영문 브라우저를 쓰는
// 사용자에게는 이렇게 나온다.
//
//   Please include an '@' in the email address. 'admin' is missing an '@'.
//
// 한국어 서비스에서 이 문장만 영어로 튀어나온다(2026-08-23 어드민 로그인에서 관측).
// 로케일 파일로는 못 고친다 — 우리 문자열이 아니다.
//
// ── 왜 전역인가 ─────────────────────────────────────────────────────────────
// 화면마다 붙이면 **새로 생긴 화면만 빠진다.** 이 저장소에서 같은 방식으로 세 번
// 어긋났다(auth 레이아웃의 alert, 메일 껍데기, 좌측 네비). 문서 하나에 한 번 걸어
// 두면 앞으로 만들 폼도 자동으로 덮인다.
//
// ── 주의 ────────────────────────────────────────────────────────────────────
// · invalid 이벤트는 **버블링하지 않는다** → capture 로 받는다.
// · setCustomValidity 로 세운 값은 **직접 지우기 전까지 남는다.** 안 지우면 입력을
//   고쳐도 계속 무효라 폼이 영영 제출되지 않는다 → input·change 에서 비운다.
// · 폼 자체의 검증을 대신하지 않는다. 서버 검증은 그대로다.

const 이메일_예시 = '예: name@company.com'

function 메시지(el) {
  const v = el.validity

  if (v.valueMissing) {
    if (el.type === 'checkbox' || el.type === 'radio') return '이 항목을 선택해 주세요.'
    if (el.tagName === 'SELECT') return '항목을 선택해 주세요.'
    return '이 항목을 입력해 주세요.'
  }

  if (v.typeMismatch) {
    if (el.type === 'email') return `이메일 주소를 정확히 입력해 주세요. (${이메일_예시})`
    if (el.type === 'url') return '주소 형식이 올바르지 않습니다.'
    return '형식이 올바르지 않습니다.'
  }

  // 패턴을 어겼을 때는 화면이 기대하는 모양을 알 수 없다. title 이 있으면 그것이
  // 가장 정확한 안내다 — 없을 때만 일반 문구로 떨어진다.
  if (v.patternMismatch) return el.title?.trim() || '형식이 올바르지 않습니다.'

  if (v.tooShort)  return `${el.minLength}자 이상 입력해 주세요.`
  if (v.tooLong)   return `${el.maxLength}자 이하로 입력해 주세요.`
  if (v.rangeUnderflow) return `${el.min} 이상으로 입력해 주세요.`
  if (v.rangeOverflow)  return `${el.max} 이하로 입력해 주세요.`
  if (v.stepMismatch)   return '올바른 값을 입력해 주세요.'
  if (v.badInput)       return '올바른 값을 입력해 주세요.'

  return null
}

document.addEventListener('invalid', (event) => {
  const el = event.target
  if (!(el instanceof HTMLElement) || typeof el.setCustomValidity !== 'function') return

  // 지난번에 세워 둔 값을 먼저 비운다 — 그래야 지금의 실제 상태를 본다.
  el.setCustomValidity('')

  const msg = 메시지(el)
  if (msg) el.setCustomValidity(msg)
}, true)

// 세워 둔 값을 지우지 않으면 입력을 고쳐도 계속 무효로 남는다.
const 비우기 = (event) => {
  const el = event.target
  if (typeof el?.setCustomValidity === 'function') el.setCustomValidity('')
}

document.addEventListener('input', 비우기, true)
document.addEventListener('change', 비우기, true)
